<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-if="marker.reports.length > 0" v-slot:activator="{}">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="dialog = true">
            <v-badge overlap v-if="marker.reports.length > 0" color="primary">
              <template v-slot:badge>{{marker.reports.length}}</template>
              <v-icon :color="marker.reports.length > 0 ? 'error': ''">report_problem</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>{{$t('reports')}}</span>
      </v-tooltip>
    </template>
    <v-card tile class="bg-grey">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Reports</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <!-- <v-toolbar-items> -->
        <!-- </v-toolbar-items> -->
      </v-toolbar>
      <v-container style="max-width: 960px" class="pa-2 mx-auto" fluid>
        <v-row>
          <v-col sm12 md6 cols="12" v-for="(report, i) in marker.reports" :key="i">
            <v-card outlined>
              <v-card-title class="overline">
                <!-- {{marker.project}} > {{marker.buildingComponent}} > {{marker.blueprint}} -->
                <v-spacer></v-spacer>
              </v-card-title>
              <v-list-item three-line>
                <v-list-item-avatar tile size="125" color="grey">
                  <v-img :src="report.image"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <b class="mr-2">{{$t('name')}} & {{$t('company')}}:</b>
                    {{report.name}} {{report.company}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <b class="mr-2">{{$t('email')}}/{{$t('phone')}}:</b>
                    {{report.email}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <b class="mr-2">{{$t('date')}}:</b>
                    {{report.date}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <b class="mr-2">{{$t('comment')}}:</b>
                    {{report.comment}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <b class="mr-2">{{$t('solution')}}:</b>
                    <template v-if="report.markerXSolutionId">
                      {{
                      report.markerXSolution
                      }}
                    </template>
                    <template v-else><span class="font-weight-bold red--text">{{$t('chooseSolution')}}</span></template>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-toolbar class="pl-0" dense flat color="transparant">
                <v-subheader>{{$t("solutionsList")}}</v-subheader>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-divider></v-divider>
              <!-- <swipe-list ref="list" class="card" :items="marker.markerXSolutions" item-key="id"> -->
              <!-- <template v-slot="{ item, index}"> -->
              <v-card
                v-for="(item,index) in marker.markerXSolutions"
                :key="index"
                class="v-card card-content mb-1"
              >
                <v-list-item-title class="pl-5 pt-2">
                  <!-- <v-card-title class="py-2"> -->
                  <template v-if="$store.state.productSolutions.find(x => x.id == item.solutionId)">
                    {{
                    `${marker.number}.${index+1} ${$store.state.productSolutions.find(x => x.id == item.solutionId).name}`
                    }}
                  </template>
                  <!-- </v-card-title> -->
                </v-list-item-title>
                <v-card-actions class="pl-5 d-flex flex-wrap">
                  <v-chip>
                    <v-icon
                      :color="item.isApproved === 1 && !item.valid ? 'red' :
                     item.isApproved === 0 && !item.valid ? 'orange':
                      item.isApproved === 2? 'success': 'primary'"
                    >{{item.isApproved === 2 ? 'check_circle' : item.isApproved === 1 ? 'priority_high': 'priority_high'}}</v-icon>
                    {{item.isApproved == 1 ? $t('broken') : item.isApproved == 2 ? $t('approved') : item.isApproved == 0 ? $t('inProcess') : $t('new') }}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="secondary"
                    text
                    v-if="report.markerXSolutionId != item.id"
                    @click="addToThisSolution(report,item)"
                  >{{$t('addReportToThisSolution')}}</v-btn>
                </v-card-actions>
                <v-divider></v-divider>
              </v-card>
              <v-card-actions class="mt-4">
                <v-spacer></v-spacer>
                <can I="delete" a="blueprints">
                  <!-- <areyousure2 v-on:delete="deleteReport" :id="report.id" object="report"></areyousure2> -->
                  <areyousure2
                    :cancelbuttonText="$t('cancel')"
                    :actionButtonText="$t('ignore')"
                    :id="report.id"
                    object="report"
                    :message="$t('areyousureyouwanttoignorethis')"
                    v-on:delete="deleteReport(report)"
                  >
                    <template v-slot:action>
                      <v-btn text color="orange" class="mr-2" depressed>{{$t('ignore')}}</v-btn>
                    </template>
                  </areyousure2>
                </can>
                <v-btn dark depressed color="secondary" @click="save">{{$t('save')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import uuid from "uuid";
import areyousure2 from "@/components/AreYouSure2";
import markerXSolutions from "@/components/pages/Markers/MarkerXSolutions/List";
export default {
  components: {
    areyousure2,
    markerXSolutions
  },
  name: "Reports",
  props: {
    marker: Object
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    addToThisSolution(report, mxs) {
      report.markerXSolutionId = mxs.id;
      report.markerXSolution = this.marker.markerXSolutions.find(
        x => x.id == report.markerXSolutionId
      ).solution.name;
      this.$forceUpdate();
    },
    close() {
      this.dialog = false;
    },
    deleteReport(report) {
      this.marker.reports = this.marker.reports.filter(p => p.id != report.id);
      if (this.marker.reports.length === 0) {
        this.close();
      }
      this.save();
    },
    save() {
      this.marker.reports.forEach(report => {
        let id = uuid.v4();
        if (report.markerXSolutionId) {
          var date = new Date();

          const attachment = {
            id: id,
            markerId: this.$route.params.id,
            markerXSolutionsId: report.markerXSolutionId,
            name: "report.jpg",
            content: report.image,
            approved: false,
            createdBy: "REPORTED",
            createdTs: date.toJSON(),
            reportId: report.id,
            new: true
          };
          this.marker.markerXSolutions
            .find(x => x.id == attachment.markerXSolutionsId)
            .attachments.unshift(attachment);
          this.$store.commit("updateMarker", this.marker);
          this.marker.reports = this.marker.reports.filter(
            x => x.id != report.id
          );
          this.$emit("updateMarker");
        }

        this.dialog = false;
      });
    }
  },
  created() {}
};
</script>




// WEBPACK FOOTER //
// src/components/pages/Markers/Reports.vue